import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import {IconButton, InputAdornment, TextField} from "@mui/material";
import React, {type FC, useState} from 'react';
import {type Control, Controller} from "react-hook-form";

interface PasswordFieldProps {
  control: Control<any>;
  name: string;
  errors: any;
  required?: boolean;
}

const PasswordField: FC<PasswordFieldProps> = ({control, name, errors, required = false}) => {
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };
  return (
    <Controller
      name={name}
      control={control}
      render={({field}) => (
        <TextField
          {...field}
          type={showPassword ? 'text' : 'password'}
          InputLabelProps={{required}}
          error={!!errors?.[name]}
          helperText={errors?.[name]?.message || (!required && field.value) || required ? <>
            Password must contain:
            <br/>
            - at least 8 characters.
            <br/>
            - at most 250 characters.
            <br/>
            - at least 1 lowercase letter.
            <br/>
            - at least 1 uppercase letter.
            <br/>
            - at least 1 number.
            <br/>
            - at least 1 symbol.
          </> : null}
          label={'Password'}
          InputProps={{
            endAdornment: <InputAdornment position="end">
              <IconButton
                aria-label={
                  showPassword ? 'hide the password' : 'display the password'
                }
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                onMouseUp={handleMouseUpPassword}
                edge="end"
              >
                {showPassword ? <VisibilityOff/> : <Visibility/>}
              </IconButton>
            </InputAdornment>,
          }}
        />
      )}
    />
  );
};

export default PasswordField;
